module.exports = __webpack_public_path__ + "media/channel_pages/cassia-blue-wildflower-tour-46e6fe21.png";